import { memo } from 'react';
import type { IIconProps } from '../interfaces';

const SpeedIcon = (props: IIconProps) => {
  const { width = 24, height = 24, color = 'currentColor' } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.25 17.2501V15.1032C2.25 9.71257 6.58125 5.26882 11.9625 5.25007C13.246 5.24514 14.5179 5.49368 15.7052 5.98146C16.8924 6.46923 17.9717 7.18663 18.881 8.09249C19.7904 8.99835 20.5119 10.0749 21.0043 11.2602C21.4966 12.4456 21.75 13.7165 21.75 15.0001V17.2501C21.75 17.449 21.671 17.6397 21.5303 17.7804C21.3897 17.9211 21.1989 18.0001 21 18.0001H3C2.80109 18.0001 2.61032 17.9211 2.46967 17.7804C2.32902 17.6397 2.25 17.449 2.25 17.2501Z" stroke={color} strokeWidth="1.50421" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 5.25V8.25" stroke={color} strokeWidth="1.50421" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2.57812 12.478L5.48438 13.2562" stroke={color} strokeWidth="1.50421" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M21.4219 12.478L18.5156 13.2562" stroke={color} strokeWidth="1.50421" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.69336 18.0001L16.1059 9.64697" stroke={color} strokeWidth="1.50421" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default memo(SpeedIcon);
